import React, { useRef } from 'react';
import { useLogisticsStore } from '../store/useLogisticsStore';
import Card from './UI/Card';
import { formatPhoneNumber } from '../utils/helpers';
import { IMAGES } from '../config/images';
import { INSTAGRAM_URL, TIKTOK_URL, X_URL, YOUTUBE_URL } from '../config/config';

const LogisticsSignatureResult = () => {
  const {
    name,
    email,
    position,
    extension,
    cellPhone,
    disclaimer,
    linkedin,
    pictureUrl,
    updatesEmail,
    hasLoadbaseBanner,
    hasWarehouse411Banner,
    hasSocials,
  } = useLogisticsStore();
  const signatureRef = useRef<HTMLDivElement>(null);
  const signatureCopyRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    if (!signatureRef.current) return;

    const html = `
    <!DOCTYPE html>
    <html>
      <head> 
        <meta charset="UTF-8" />
        <title>Signature</title> 
      </head>
      <body>
        ${signatureRef.current.innerHTML}
      </body>
    </html>
  `.trim();

    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'gmail-signature.html';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  return (
    <>
      <Card title='Your Signature Result'
        action={{
          label: 'Download Signature',
          onClick: () => handleDownload()
        }}
      >
        <div className='flex flex-col text-sm text-slate-400'>
          <p className='pb-4'>Hi John,</p>
          <p>
            I hope you're doing well. Please find attached the updated shipping documents for the upcoming
            dispatch scheduled for Friday. Let me know if there’s anything else you need or if any changes
            are required before we proceed.
          </p>
          <p>
            Also, quick reminder that the deadline for final approval is{' '}
            <span className="font-medium">Thursday, 5 PM EST</span>.
          </p>
          <div className="pt-4 pb-6">
            <p>Best regards,</p>
          </div>
        </div>
        <div ref={signatureRef}>
          <table
            style={{
              color: 'rgb(80, 0, 80)',
              tableLayout: 'fixed',
              width: '620px',
              fontFamily: 'Helvetica, sans-serif',
              fontSize: '14px',
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    borderRight: '1px solid rgb(226, 232, 240)',
                    borderTop: '1px solid rgb(226, 232, 240)',
                    paddingRight: '1rem',
                    width: '190px',
                    verticalAlign: 'middle',
                  }}
                >
                  <p style={{ margin: '0.5rem 0px 0px' }}>
                    {pictureUrl && (
                      <img
                        src={pictureUrl}
                        width={100}
                        height={100}
                        alt="Profile"
                        style={{
                          borderRadius: '50%',
                          display: 'block',
                          margin: '0 auto'
                        }}
                      />
                    )}
                  </p>
                  <img
                    alt="SIERRA LOGISTICS SOLUTIONS DBA SHIPSIERRA.COM"
                    src="https://sendsierra.com/sierra-logistics.png"
                    style={{
                      width: '188px',
                      height: '40px',
                      marginTop: '0.4rem',
                    }}
                  />
                  <p
                    style={{
                      margin: '0.5rem 0px 0px',
                      padding: 0,
                      color: 'rgb(39, 39, 42)',
                      textAlign: 'center',
                      fontSize: '12px',
                    }}
                  >
                    <b>Solving Tomorrow&apos;s Problems...</b>
                  </p>
                  <p
                    style={{
                      margin: '0.2rem 0px 0px',
                      padding: 0,
                      color: 'rgb(204, 20, 20)',
                      textAlign: 'center',
                      fontSize: '12px',
                    }}
                  >
                    <b>TODAY.</b>
                  </p>
                </td>
                <td
                  style={{
                    width: '420px',
                    paddingLeft: '1rem',
                    borderTop: '1px solid rgb(226, 232, 240)',
                  }}
                >
                  <table
                    cellSpacing={0}
                    cellPadding={0}
                    border={0}
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontSize: '14px',
                      lineHeight: '1.4',
                      color: '#000',
                      width: '100%',
                      maxWidth: '500px',
                    }}
                  >
                    <tbody>
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          margin: '0.2rem 0px 0px',
                          padding: 0,
                          color: 'rgb(0, 0, 0)',
                        }}
                      >
                        <b>{name || 'John Doe'}</b>
                        {linkedin && (
                          <a href={`${linkedin}`} target='_blank' rel="noreferrer" style={{ display: 'flex', marginLeft: '6px' }}>
                            <img alt='LinkedIn' src='https://sendsierra.com/in.png' width={18} height={18} />
                          </a>
                        )}
                        <br />
                      </p>
                      <p style={{
                        margin: '0.1rem 0px',
                        padding: 0,
                        color: 'rgb(204, 20, 20)',
                      }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            color: '#94a3b8',
                            borderRadius: '3px',
                          }}
                        >
                          {position || 'Dispatch'}
                        </span>
                      </p>
                      <p
                        style={{
                          margin: '0.1rem 0px',
                          padding: 0,
                          color: 'rgb(204, 20, 20)',
                        }}
                      >
                        <strong>SHIPSIERRA.COM</strong>
                      </p>
                      <p
                        style={{
                          margin: '0.2rem 0px',
                          padding: 0,
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: 'rgb(204, 20, 20)',
                            color: 'rgb(255, 255, 255)',
                            borderRadius: '3px',
                            padding: '0.2rem 0.4rem',
                          }}
                        >
                          MC: 137469
                        </span>
                        &nbsp;
                        <span
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: 'rgb(204, 20, 20)',
                            color: 'rgb(255, 255, 255)',
                            borderRadius: '3px',
                            padding: '0.2rem 0.4rem',
                          }}
                        >
                          DOT: 3192183
                        </span>
                      </p>
                      <p style={{ margin: '0.1rem 0', padding: 0 }}>
                        <span style={{ color: '#cc1414' }}>
                          <b>P: </b>
                        </span>
                        <a
                          href="tel:+19168854045"
                          rel="noopener noreferrer"
                          style={{ color: 'rgb(9, 9, 11)', textDecoration: 'none' }}
                          target="_blank"
                        >
                          (916) 885 4045 {extension ? `ext.${extension}` : ''}
                        </a>{' '}
                        {cellPhone && (
                          <>
                            <span style={{ color: '#cc1414' }}>
                              <b>M: </b>
                            </span>
                            <a
                              href={`tel:${formatPhoneNumber(cellPhone)}`}
                              rel="noopener noreferrer"
                              style={{ color: 'rgb(9, 9, 11)', textDecoration: 'none' }}
                              target="_blank"
                            >
                              {cellPhone}
                            </a>
                          </>
                        )}
                      </p>

                      <p style={{ margin: '0.1rem 0', padding: 0 }}>
                        <span style={{ color: '#cc1414' }}>
                          <b>E: </b>
                        </span>
                        <a
                          href={`mailto:${email}`}
                          style={{
                            color: 'rgb(9, 9, 11)',
                            textDecoration: 'none',
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {email || 'john.doe@shipsierra.com'}
                        </a>
                      </p>
                      <p style={{ margin: '0.1rem 0', padding: 0 }}>
                        <span style={{ color: '#cc1414' }}>
                          <b>W: </b>
                        </span>
                        <a href='https://shipsierra.com' target='_blank' rel="noreferrer"
                          style={{ color: 'rgb(9, 9, 11)', textDecoration: 'none' }}
                        >
                          shipsierra.com
                        </a>
                      </p>
                      {updatesEmail && (
                        <p style={{ margin: '0.1rem 0', padding: 0 }}>
                          <span style={{ color: '#cc1414' }}>
                            <b>For updates email: </b>
                          </span>
                          <a
                            href={`mailto:${updatesEmail}`} rel="noreferrer"
                            target="_blank"
                            style={{ color: '#09090b', textDecoration: 'none' }}
                          >
                            {updatesEmail}
                          </a>
                        </p>
                      )}
                    </tbody>
                  </table>

                  {(hasLoadbaseBanner || hasWarehouse411Banner) && (
                    <table cellPadding={0} cellSpacing={0} border={0} style={{ marginTop: '0.5rem' }}>
                      <tbody>
                        <tr>
                          {hasLoadbaseBanner && (
                            <td style={{ paddingRight: hasWarehouse411Banner ? '15px' : '0px' }}>
                              <img
                                src="https://sendsierra.com/loadbase.png"
                                width={110}
                                height={20}
                                alt="Loadbase"
                                style={{ display: 'block', border: 0 }}
                              />
                            </td>
                          )}
                          {hasWarehouse411Banner && (
                            <td>
                              <img
                                src="https://sendsierra.com/wh411.png"
                                width={160}
                                height={20}
                                alt="Warehouse411"
                                style={{ display: 'block', border: 0 }}
                              />
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  )}

                  {hasSocials && <table cellPadding={0} cellSpacing={0} border={0} style={{ borderSpacing: '10px 0', borderCollapse: 'separate', marginTop: '0.5rem', marginLeft: '-10px', }}>
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src={IMAGES.logos.facebook}
                            width={20}
                            height={20}
                            alt="Facebook"
                            style={{ display: 'block', border: 0 }}
                          />

                        </td>

                        <td>
                          <a href={TIKTOK_URL}>
                            <img
                              src={IMAGES.logos.tiktok}
                              width={20}
                              height={20}
                              alt="TikTok"
                              style={{ display: 'block', border: 0 }}
                            />
                          </a>
                        </td>
                        <td>
                          <a href={X_URL}>
                            <img
                              src={IMAGES.logos.x}
                              width={18}
                              height={18}
                              alt="X"
                              style={{ display: 'block', border: 0 }}
                            />
                          </a>
                        </td>
                        <td>
                          <a href={INSTAGRAM_URL}>
                            <img
                              src={IMAGES.logos.instagram}
                              width={20}
                              height={20}
                              alt="Instagram"
                              style={{ display: 'block', border: 0 }}
                            />
                          </a>
                        </td>
                        <td>
                          <a href={YOUTUBE_URL}>
                            <img
                              src={IMAGES.logos.youtube}
                              width={30}
                              height={30}
                              alt="YouTube"
                              style={{ display: 'block', border: 0 }}
                            />
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>}
                </td>
              </tr>
            </tbody>
          </table>

          {disclaimer && (
            <table style={{ width: '620px', marginTop: '0.75rem' }}>
              <tbody>
                <tr>
                  <td style={{ fontSize: '10px', color: '#64748b', textAlign: 'justify' }}>
                    {disclaimer}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div
          ref={signatureCopyRef}
          style={{ position: 'absolute', left: '-9999px', top: 0 }}
          contentEditable
          dangerouslySetInnerHTML={{ __html: signatureRef.current?.outerHTML ?? '' }}
        />
      </Card>
    </>
  );
};

export default LogisticsSignatureResult;
